/// <reference path="../types/index.d.ts" />

import '../client_forms/nibblers/style.css';
import FormStructure from './nibblers/form_structure';

export default FormStructure;